import React from 'react';
import styled from 'styled-components';
import { Fade } from "react-awesome-reveal";
import h1 from '../Images/h1.png'
import h2 from '../Images/h2.png'
import h3 from '../Images/h3.png'
import h4 from '../Images/h4.png'
import h5 from '../Images/h5.png'
import h6 from '../Images/h6.png'

// --- Styled Components ---

const GallerySection = styled.section`
  padding: 10px 20px;
  max-width: 1200px;
  margin: 0 auto;
  border-top:1px solid green;
`;

const GalleryTitle = styled.h2`
  text-align: center;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 10px;
  text-transform: uppercase;
  color: #439E6D;
`;

const Grid = styled.div`
  display: grid;
  gap: 10px;

  /* Desktop: 3 columns */
  grid-template-columns: repeat(3, 1fr);

  /* Tablet/Mobile: 2 columns */
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  /* Small Mobile: 1 column (Optional, but recommended for tiny screens) */
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const ImageCard = styled.div`
  position: relative;
  height: 250px;
  overflow: hidden;
  border-radius: 4px;
  border: 4px solid #439E6D; // Matches your navy blue theme
  background-color: #eee;
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;

  ${ImageCard}:hover & {
    transform: scale(1.1);
  }
`;

const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(13, 42, 113, 0.85); // Transparent navy
  color: white;
  padding: 15px;
  transform: translateY(100%);
    transition: transform 0.3s ease-in-out;

  ${ImageCard}:hover & {
    transform: translateY(0);
  }
`;

const ProjectName = styled.h4`
  margin: 0;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

// --- Mock Data ---

const projects = [
  { id: 1, title: "Offshore Rig Deck", img: h1 },
  { id: 2, title: "Precision Surveying", img: h2 },
  { id: 3, title: "Bathymetric Vessel", img: h3 },
  { id: 4, title: "Coastal Fabrication", img: h4 },
  { id: 5, title: "Project Planning", img: h5 },
  { id: 6, title: "Land Survey Marker", img: h6 },
];

// --- Component ---

const ProjectGallery = () => {
  return (
    <GallerySection>
      <Fade triggerOnce>
        <GalleryTitle>Project Gallery</GalleryTitle>
      </Fade>

      <Grid>
        <Fade cascade damping={0.15} triggerOnce>
          {projects.map((project) => (
            <ImageCard key={project.id}>
              <StyledImage src={project.img} alt={project.title} />
              <Overlay>
                <ProjectName>{project.title}</ProjectName>
              </Overlay>
            </ImageCard>
          ))}
        </Fade>
      </Grid>
    </GallerySection>
  );
};

export default ProjectGallery;